import React from "react";
import DataTable from "../../DataTable";

const OtherPayments = ({ other }) => {
  if (other && Array.isArray(other) && other.length > 0) {
    return (
      <div style={{ marginBottom: "20px" }}>
        {console.log("da", other)}
        <div style={{ borderBottom: "1px solid red" }} className="mb-2">
          <h4 style={{ fontSize: "18px" }}>لیست پرداخت ها</h4>
        </div>
        <div className="row justify-content-between ">
          <DataTable
            heads={[
              {
                title: "نوع پرداخت",
                key: "type_payment",
                type: "enum",
                enum: {
                  gateway: "پرداخت آنلاین",
                  wallet: "پرداخت از کیف پول",
                  others: "پرداخت در محل",
                },
              },
              {
                title: "شماره تراکنش",
                key: "transid",
              },
              {
                title: "شماره پیگری پرداخت",
                key: "trackingcode",
              },
              {
                title: "مبلغ",
                key: "total_price",
              },
              {
                title: "وضعیت",
                key: "status",
                type: "enum",
                enum: {
                  peyed: "پرداخت شده",
                  error: "عدم پرداخت",
                  waittopay: "پرداخت رها شده",
                },
              },
              {
                title: "زمان پرداخت ",
                key: "created_at",
                type: "date",
                timetype: "date-time",
              },
            ]}
            short={true}
            textEmpty="همراهی وجود ندارد"
            list={other}
            data={other}
          />
        </div>
      </div>
    );
  }
  return <></>;
};

export default OtherPayments;
